import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageDashboardComponent implements OnInit {
    public loading: boolean = true;
    public projects: any[] = [];
    public stats: any = { total: 0, active: 0, average: 0, versions: 0 };
    public search: string = '';
    public showCreate: boolean = false;
    public creating: boolean = false;
    public viewMode: string = 'grid';

    public createData: any = {
        name: '',
        client: '',
        description: '',
        start_date: '',
        end_date: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('overview');
        if (code === 200) {
            this.projects = data.projects || [];
            this.stats = data.stats || this.stats;
        }
        this.loading = false;
        await this.service.render();
    }

    public filteredProjects() {
        const query = this.search.trim().toLowerCase();
        if (!query) return this.projects;
        return this.projects.filter((project) => {
            return [project.name, project.client, project.description]
                .join(' ').toLowerCase().includes(query);
        });
    }

    public openCreate() {
        this.createData = {
            name: '',
            client: '',
            description: '',
            start_date: '',
            end_date: ''
        };
        this.showCreate = true;
        this.service.render();
    }

    public async createProject() {
        if (!this.createData.name.trim()) {
            await this.service.modal.error('프로젝트명을 입력해주세요.');
            return;
        }
        this.creating = true;
        await this.service.render();
        const { code, data } = await wiz.call('create', {
            data: JSON.stringify(this.createData)
        });
        this.creating = false;
        if (code === 200 && data.id) {
            this.showCreate = false;
            this.service.href('/projects/' + data.id + '/wbs');
            return;
        }
        await this.service.modal.error(
            data && data.message ? data.message : '프로젝트를 만들지 못했습니다.'
        );
        await this.service.render();
    }

    public async removeProject(project: any) {
        const confirmed = await this.service.modal.show({
            title: '프로젝트 보관',
            message: project.name + ' 프로젝트를 목록에서 보관하시겠습니까? 데이터와 파일은 보존됩니다.',
            action: '보관',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call('remove', { id: project.id });
        if (code === 200) {
            await this.load();
            return;
        }
        await this.service.modal.error(
            data && data.message ? data.message : '프로젝트를 보관하지 못했습니다.'
        );
    }

    public statusLabel(status: string) {
        const labels: any = {
            active: '진행중',
            planning: '계획',
            completed: '완료',
            archived: '보관'
        };
        return labels[status] || status;
    }

    public statusClass(status: string) {
        if (status === 'active') return 'bg-emerald-50 text-emerald-700 ring-emerald-600/15';
        if (status === 'completed') return 'bg-blue-50 text-blue-700 ring-blue-600/15';
        if (status === 'planning') return 'bg-amber-50 text-amber-700 ring-amber-600/15';
        return 'bg-slate-100 text-slate-600 ring-slate-500/15';
    }

    public progressColor(progress: number) {
        if (progress >= 80) return 'bg-emerald-500';
        if (progress >= 40) return 'bg-teal-600';
        return 'bg-amber-400';
    }

    public dateText(value: any) {
        if (!value) return '일정 미정';
        return String(value).substring(0, 10).replaceAll('-', '.');
    }
}

export default PageDashboardComponent;